<template>
  <div>
    <b-row class="match-height mt-1">
      <b-col lg="12">
        <SEMDiagram />
      </b-col>
      <b-col lg="6">
        <SEMChartAmp />
      </b-col>
      <b-col
        v-if="sem_type !== 'nbiot_cab_1p'"
        lg="6"
      >
        <SEMLine />
        <br>
      </b-col>
      <b-col lg="6">
        <SEMChart />
      </b-col>
      <b-col
        v-if="sem_type == 'nbiot_cab_1p'"
        lg="6"
      >
        <SEMMap />
      </b-col>
      <b-col lg="6">
        <SEMStatic />
      </b-col>
      <br>
      <b-col lg="12">
        <SEMLog />
      </b-col>
      <b-col
        v-if="sem_type !== 'nbiot_cab_1p'"
        lg="12"
      >
        <SEMMap />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import axios from '@axios'
import SEMDiagram from '@/views/lighting/semcontrol1/SEMDiagram.vue'
import SEMMap from '@/views/lighting/semcontrol1/SEMMapDetail.vue'
import SEMLine from '@/views/lighting/semcontrol1/CheckLine.vue'
import SEMChartAmp from '@/views/lighting/semcontrol1/SEMChartAmp.vue'
import SEMChart from '@/views/lighting/semcontrol1/SEMChart.vue'
import SEMStatic from '@/views/lighting/semcontrol1/SEMStatic.vue'
import SEMLog from '@/views/lighting/semcontrol1/SEMLog.vue'
// import axios from '@axios'
export default {
  components: {
    BRow,
    BCol,
    SEMMap,
    SEMChartAmp,
    SEMDiagram,
    SEMChart,
    SEMLog,
    SEMLine,
    SEMStatic,
  },
  data() {
    return {
      sem_type: '',
      diagram_type: '',
    }
  },
  mounted() {
    this.getValueDiagram()
  },
  methods: {
    getValueDiagram() {
      axios
        .post('/valueDiagram', { wid: this.$route.query.wid })
        .then(response => {
          this.sem_type = response.data[0].firmware
          this.diagram_type = response.data[0].diagram_type
          // eslint-disable-next-line prefer-destructuring
          console.log(this.sem_type)
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style>
</style>
